import { MenuListProps, Options } from "react-select";

import { FILTER_CONST } from "./filter-multiselect-models";

interface IMenuListInitialOffsetResolveArgs {
  maxHeight: number;
  values: Options<unknown>;
  filteredOptions: MenuListProps["options"];
}

export const menuListInitialOffsetResolve = ({
  maxHeight,
  values,
  filteredOptions,
}: IMenuListInitialOffsetResolveArgs): number => {
  if (filteredOptions.length === values.length) {
    return 0;
  }

  const lastChosenValue = values.at(values.length - 1);
  return filteredOptions?.length * FILTER_CONST.LIST_ITEM_HEIGHT > maxHeight
    ? filteredOptions.indexOf(lastChosenValue) * FILTER_CONST.LIST_ITEM_HEIGHT
    : 0;
};
